module.exports = __webpack_public_path__ + "img/vs.0f843925.png";